import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ArrowLeft } from "lucide-react";
import { getGalleryPayments } from "../../services/walletService";
import Loader from "../../components/common/Loader";
import EmptyState from "../../components/common/EmptyState";
import { color, radius } from "../../styles/theme";

/**
 * Gallery Payment Detail — ported from mobile's gallery-payment-detail
 * screen (src/Screens/gallery-payment-detail): the individual buyer
 * transactions behind one gallery's total in Wallet.
 */
const GalleryPaymentDetail = () => {
  const { t } = useTranslation(["wallet", "common"]);
  const { galleryId } = useParams();
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getGalleryPayments(galleryId)
      .then((res) => setPayments(res.data?.Result || []))
      .catch(() => toast.error(t("galleryPaymentDetail.loadError")))
      .finally(() => setLoading(false));
  }, [galleryId, t]);

  if (loading) return <Loader />;

  return (
    <div>
      <button type="button" className="btn btn-ghost btn-sm" style={s.linkBtn} onClick={() => navigate("/wallet")}>
        <ArrowLeft size={13} strokeWidth={2.25} /> {t("galleryPaymentDetail.backToWallet")}
      </button>
      <h2 style={s.title}>{t("galleryPaymentDetail.title")}</h2>

      {payments.length === 0 ? (
        <EmptyState text={t("galleryPaymentDetail.emptyState")} />
      ) : (
        <div style={s.list}>
          {payments.map((p, i) => (
            <div key={i} style={s.row}>
              <div style={s.buyer}>
                {p.DisplayPicture ? (
                  <img src={p.DisplayPicture} alt="" style={s.avatar} />
                ) : (
                  <div style={s.avatarFallback}>{(p.UserNickname || "?").charAt(0).toUpperCase()}</div>
                )}
                <span>{p.UserNickname}</span>
              </div>
              <span style={s.amount}>{t("galleryPaymentDetail.paidLabel", { amount: p.Amount, currency: p.Currency })}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const s = {
  linkBtn: { color: color.gray600, fontWeight: 600, marginBottom: 8, padding: "6px 10px" },
  title: { fontSize: 19, fontWeight: 800, color: color.textPrimary, marginBottom: 18, letterSpacing: -0.3 },
  list: { maxWidth: 480, display: "flex", flexDirection: "column", gap: 10 },
  row: { display: "flex", justifyContent: "space-between", alignItems: "center", background: color.surface, border: `1px solid ${color.border}`, borderRadius: radius.sm, padding: "12px 16px" },
  buyer: { display: "flex", alignItems: "center", gap: 10, fontSize: 13 },
  avatar: { width: 24, height: 24, borderRadius: "50%", objectFit: "cover" },
  avatarFallback: {
    width: 24, height: 24, borderRadius: "50%", background: color.primary500, color: "#fff",
    fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center",
  },
  amount: { fontSize: 13, fontWeight: 600, color: color.gray800 },
};

export default GalleryPaymentDetail;
